import './CatalogContainer.css';

import * as React from 'react';

import { IDocument, IPage, IPlaceHolder, ISpread, IDragInfo } from '../../../../../infrastructure/interfaces';
import { PageType } from '../../../../../infrastructure/PageType';
import BackLayout from '../common/BackLayout';
import FrontLayout from '../common/FrontLayout';
import PageLayout from './Components/PageLayout';
import {stringIdentifierForLayoutType} from '../../../../../infrastructure/LayoutTypes';

export interface ICatalogProps {
  document: IDocument | null;
  isSpreadView: boolean;
  spreadToRender?: ISpread;
  pageToRender?: IPage;
  disclaimers: any[];
  isEditorRendering: boolean;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  moveCrop(dragIndex: number, hoverIndex: number): void;
}
export interface ICatalogState {
  document: IDocument;
}
export default class CatalogContainer extends React.Component<ICatalogProps, ICatalogState> {

  renderPage(page: IPage, second: boolean, layout: string) {
    return (
      <PageLayout
        page={page}
        second={second}
        removeProduct={this.props.removeProduct}
        handleDrop={this.props.handleDrop}
        document={this.props.document}
        layout={layout}
        isEditorRendering={this.props.isEditorRendering}
      />
    );
  }

  renderLeftPage(page: IPage, second: boolean) {
    let layout: string = stringIdentifierForLayoutType(page.layout);
    return (
      <PageLayout
        page={page}
        second={second}
        removeProduct={this.props.removeProduct}
        handleDrop={this.props.handleDrop}
        document={this.props.document}
        layout={layout}
        isEditorRendering={this.props.isEditorRendering}
      />
    );
  }

  renderRightPage(page: IPage, second: boolean) {
    let layout: string = stringIdentifierForLayoutType(page.layout);
    return (
      <PageLayout
        page={page}
        second={second}
        removeProduct={this.props.removeProduct}
        handleDrop={this.props.handleDrop}
        document={this.props.document}
        layout={layout}
        isEditorRendering={this.props.isEditorRendering}
      />
    );
  }

  renderFront = () => {
    const {
      document,
      moveCrop,
    } = this.props;

    return (
      <FrontLayout
        document={document}
        moveCrop={moveCrop}
        isSpreadView={this.props.isSpreadView}
        isEditorRendering={this.props.isEditorRendering}
        isWebPageCover={true}
        mainView={true}
      />
    );
  }

  renderBack = () => {
    return (
      <BackLayout
        document={this.props.document}
        brandings={this.props.document!.brandings}
        isEditorRendering={this.props.isEditorRendering}
        isWebPageCover={true}
        disclaimers={this.props.disclaimers}
      />
    );
  }

  renderSpread(spread: ISpread) {
    if (spread === null) {
      return null;
    }

    if (spread.right) {
      if (spread.left.type === PageType.Page && spread.right.type === PageType.Page) {
        return (
          <div>
            <div className={`crop-cont`}>
              {this.renderLeftPage(spread.left, false)}
              {this.renderRightPage(spread.right, true)}
            </div>
          </div>
        );
      }
    } else {
      if (spread.left.type === PageType.Page) {
        return (
          <div>
            <div className={`crop-cont`}>
             {this.renderLeftPage(spread.left, false)}
            </div>
          </div>
        );
      }
    }

    const isRenderingCover = (spread.left.type === PageType.Back && ((spread.right != null) && (spread.right.type === PageType.Front)));
    if (isRenderingCover) {
      return (
        <div className={`crop-cont crop-cont--cover`}>
          {this.renderBack()}
          {this.renderFront()}
        </div>
      );
    }
    return null;
  }
  renderSingle(selectedPage: IPage) {

    let layout: string = stringIdentifierForLayoutType(selectedPage.layout);

    switch (selectedPage.type) {
      case PageType.Page:
        return (
          <div className={`crop-cont`}>
            {this.renderPage(selectedPage, selectedPage.position === 'right', layout)}
          </div>);
      case PageType.Front:
        return (
          <div className={`crop-cont crop-cont--cover`}>
            {this.renderFront()}
          </div>
        );
      case PageType.Back:
        return (
          <div className={`crop-cont crop-cont--cover`}>
            {this.renderBack()}
          </div>
        );
      default:
        return (
          <div></div>
        );
    }
  }

  render() {
    return (
      this.props.isSpreadView
        ? this.renderSpread(this.props.spreadToRender!)
        : this.renderSingle(this.props.pageToRender!)
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Catalog/CatalogContainer.tsx